/**
 * SubscriptionSuspendedPage — Tela exibida quando assinatura está suspensa no Azure Marketplace.
 * O acesso ao produto fica bloqueado até a assinatura ser reativada (pagamento regularizado).
 */
import React from 'react';

const BRAND_GREEN = '#064e3b';
const BRAND_GOLD  = '#b48c2c';

export default function SubscriptionSuspendedPage() {
  const handleLogout = () => {
    localStorage.removeItem('arena_stats_user');
    window.location.href = '/login';
  };

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-4 py-12"
      style={{ background: 'linear-gradient(135deg, #fef9f0 0%, #fef3c7 100%)' }}
    >
      {/* Logo */}
      <div className="flex items-center gap-3 mb-8">
        <div
          className="w-12 h-12 rounded-xl flex items-center justify-center shadow-md"
          style={{ background: BRAND_GREEN }}
        >
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
            <path d="M3 7l9-4 9 4v10l-9 4-9-4V7z" stroke="white" strokeWidth="1.8" strokeLinejoin="round" />
          </svg>
        </div>
        <div>
          <div className="font-extrabold text-xl" style={{ color: BRAND_GREEN }}>VUKZ Platform</div>
        </div>
      </div>

      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl border border-amber-200 shadow-lg overflow-hidden">
          {/* Faixa */}
          <div className="h-2 bg-amber-400" />

          <div className="p-8 text-center">
            {/* Ícone */}
            <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-4">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
                  stroke="#d97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>

            <h2 className="text-xl font-extrabold text-gray-900 mb-2">
              Assinatura Suspensa
            </h2>
            <p className="text-sm text-gray-600 mb-1">
              Sua assinatura no Azure Marketplace está suspensa, geralmente por falha no pagamento.
            </p>
            <p className="text-sm text-gray-500 mb-6">
              Regularize o pagamento no <strong>Azure Portal</strong> para restaurar o acesso.
            </p>

            {/* Ações */}
            <div className="space-y-3">
              <a
                href="https://portal.azure.com/#blade/Microsoft_Azure_Marketplace/MarketplaceOffersBlade"
                target="_blank"
                rel="noreferrer"
                className="block w-full py-3 rounded-xl font-bold text-sm text-white text-center transition hover:opacity-90"
                style={{ background: BRAND_GOLD }}
              >
                Gerenciar no Azure Portal →
              </a>
              <a
                href="mailto:suporte@vukz.ai?subject=Assinatura%20Suspensa"
                className="block w-full py-3 rounded-xl border border-gray-200 text-gray-600 font-medium text-sm text-center hover:bg-gray-50 transition"
              >
                Contatar Suporte
              </a>
              <button
                onClick={handleLogout}
                className="block w-full py-2 text-xs text-gray-400 hover:text-gray-600 transition"
              >
                Sair da conta
              </button>
            </div>
          </div>
        </div>

        <p className="mt-6 text-xs text-gray-400 text-center">
          Se o pagamento já foi regularizado, aguarde alguns minutos para o acesso ser restaurado automaticamente.
        </p>
      </div>
    </div>
  );
}
